import 'fancybox';
/**
 *
 * Base
 *
 */


( function( $ ) {
	'use strict';

	$( 'body' ).addClass( 'mts-loaded' );

	$( window ).scroll( function() {
		var scroll = $( window ).scrollTop();
		if( 60 <= scroll ) {
			$( 'body' ).addClass( 'is-scrolled' );
		}
		if( 59 >= scroll ) {
			$( 'body' ).removeClass( 'is-scrolled' );
		}
	} );

} )( jQuery );

( function( $ ) {
	'use strict';

	$( 'a[href^="#"]' ).on( 'click', function ( e ) {
		e.preventDefault();

		var target = this.hash;
		var $target = $( target );

		$( 'html, body' ).stop().animate( {
			'scrollTop': $target.offset().top
		}, 900, 'swing', function () {
			window.location.hash = target;
		} );
	} );
} ) ( jQuery );

( function( $ ) {
	'use strict';

	$( '[data-fancybox]' ).fancybox( {
		focus: false,
		buttons: [ 'close' ],
		animationEffect: 'zoom-in-out',
		iframe: {
			preload: true
		}
	} );
	$.fancybox.defaults.hash = false;

} ) ( jQuery );

( function( $ ) {
	'use strict';

	$( '.has-arrow' ).append( '&nbsp;<i class="icon-arrow-right"></i>' );
	$( '.has-download' ).append( '&nbsp;<i class="icon-download"></i>' );

} )( jQuery );

( function( $ ) {
	'use strict';

	$( '.accordion__content-wysiwyg' ).find( 'table' ).wrap( '<div class="table-container"></div>' );
} )( jQuery );
